/**
 * Demo e debug: iniezione dataset demo
 */
import { log } from "../utils/logger.js";
import { filtersManager } from "../features/filters/index.js";

export const demoDebugMethods = {
  injectDemoPlayers() {
    log.info('🎨 Iniezione dataset demo giocatori Serie A');

    const demoPlayers = [
      { id: 1, name: 'Mike Maignan', team: 'Milan', role: 'POR', quot: 12, roles: ['POR'] },
      { id: 2, name: 'Samir Handanović', team: 'Inter', role: 'POR', quot: 8, roles: ['POR'] },
      { id: 3, name: 'Theo Hernández', team: 'Milan', role: 'DD', quot: 23, roles: ['DD'] },
      { id: 4, name: 'Alessandro Bastoni', team: 'Inter', role: 'DC', quot: 18, roles: ['DC', 'DD'] },
      { id: 5, name: 'Gleison Bremer', team: 'Juventus', role: 'DC', quot: 15, roles: ['DC'] },
      { id: 6, name: 'Juan Cuadrado', team: 'Juventus', role: 'DD', quot: 14, roles: ['DD', 'E'] },
      { id: 7, name: 'Nicolò Barella', team: 'Inter', role: 'M', quot: 26, roles: ['M', 'C'] },
      { id: 8, name: 'Sergej Milić-Savić', team: 'Lazio', role: 'M', quot: 22, roles: ['M'] },
      { id: 9, name: 'Manuel Locatelli', team: 'Juventus', role: 'M', quot: 18, roles: ['M'] },
      { id: 10, name: 'Sandro Tonali', team: 'Newcastle', role: 'M', quot: 20, roles: ['M'] },
      { id: 11, name: 'Federico Chiesa', team: 'Juventus', role: 'W', quot: 25, roles: ['W', 'E', 'A'] },
      { id: 12, name: 'Rafael Leão', team: 'Milan', role: 'W', quot: 28, roles: ['W', 'A'] },
      { id: 13, name: 'Khvicha Kvaratskhelia', team: 'Napoli', role: 'W', quot: 24, roles: ['W'] },
      { id: 14, name: 'Paulo Dybala', team: 'Roma', role: 'T', quot: 22, roles: ['T', 'A', 'W'] },
      { id: 15, name: 'Hakan Çalhanoglu', team: 'Inter', role: 'T', quot: 20, roles: ['T', 'M', 'C'] },
      { id: 16, name: 'Victor Osimhen', team: 'Napoli', role: 'A', quot: 32, roles: ['A'] },
      { id: 17, name: 'Lautaro Martínez', team: 'Inter', role: 'A', quot: 30, roles: ['A'] },
      { id: 18, name: 'Dusan Vlahović', team: 'Juventus', role: 'A', quot: 28, roles: ['A'] },
      { id: 19, name: 'Ciro Immobile', team: 'Lazio', role: 'A', quot: 26, roles: ['A'] },
      { id: 20, name: 'Tammy Abraham', team: 'Roma', role: 'A', quot: 18, roles: ['A'] },
      { id: 21, name: 'Lorenzo Insigne', team: 'Toronto FC', role: 'W', quot: 15, roles: ['W', 'T', 'A'] },
      { id: 22, name: 'Marco Verratti', team: 'PSG', role: 'M', quot: 22, roles: ['M', 'C'] },
      { id: 23, name: 'Ciro Immobile Jr', team: 'Besiktas', role: 'A', quot: 12, roles: ['A', 'W'] },
      { id: 24, name: 'Lorenzo Pellegrini', team: 'Roma', role: 'M', quot: 19, roles: ['M', 'T', 'C'] },
      { id: 25, name: 'Domenico Berardi', team: 'Sassuolo', role: 'W', quot: 17, roles: ['W', 'A', 'T'] },
      { id: 26, name: 'Matteo Politano', team: 'Napoli', role: 'W', quot: 14, roles: ['W', 'E', 'A', 'T'] },
    ];

    this.state.allPlayers = demoPlayers;
    this.state.playersHydrated = demoPlayers;

    if (window.state) {
      window.state.players = demoPlayers;
      window.state.playersHydrated = demoPlayers;
    }

    if (filtersManager) {
      filtersManager.setPlayers(demoPlayers);
      filtersManager.applyFilters();
    }

    log.info(`✅ Dataset demo caricato: ${demoPlayers.length} giocatori Serie A`);
    return demoPlayers;
  },

  showDemoHelp() {
    console.log(
      `%c
┌─────────────────────────────────────────────┐
│            🚀 FANTAPP - COMANDI DEMO            │
├─────────────────────────────────────────────┤
│   Alt+D / injectDemo()  → Carica demo          │
│   window.diag()         → Diagnostica          │
│   demoHelp()            → Questo help            │
└─────────────────────────────────────────────┘
`,
      'color: #0066cc; font-family: monospace; font-size: 12px;'
    );
    return { shortcut: 'Alt+D', commands: { injectDemo: 'Carica giocatori demo' } };
  },
};
